
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kassierer-data-view',
  imports: [],
  templateUrl: './kassierer.list-view.html',
  styleUrls: ['./kassierer.list-view.css'],
})
export class KassiererListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {
    //
  }
}
